module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page case-study ruggedian",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "landing"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('router-link', {
    staticClass: "more",
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', [_vm._v("More Case Studies →")])])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ruggedian-text-1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v("Ruggedians are a group of adrenaline and fitness junkies hailing from the city of Kolhapur. The founder, Akash Korgaonkar is a Ironman Finisher came back with the desire to bring the same experience in India. Thus was born Ruggedian (Rugged + Indian) - India’s toughest and longest obstalce race. After an encouraging start in Kolhapur, they wanted to bring the race to the people in Pune. They found a harmonious relationship with Radio Mirchi and plan-a.")])])]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/ruggedian-image-1.jpg")
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ruggedian-text-2.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("The aim was simple to generate massive buzz in Pune and Rest Of Maharashtra about the obstalce race and start a movement of encouraging participation in activities that push the limits of physical & mental resilience.  Another challenge was that they wanted to tap in to the market of Mumbai as well withouth having to using mainstream media.  To achieve this, Radio Mirchi & Mirchi Activations collaborated with us to deliver on their objectives and help kickstart the Ruggedian revolution.")]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/ruggedian-image-2.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ruggedian-text-3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v("Digital marketing was always going to be the go to springboard to accomplish 2 things"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              A) Create buzz about the event in a short span of time amongst the fitness community and attract a general audience"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n              B) Establish Ruggedian in the minds of an active audience in Mumbai without actually “going there”")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12 cross"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', [_c('p', [_vm._v("Health & Fitness, Racing, Running all have a common sentiment flowing through it - A sense of competition & accomplishment. We capitalised on this sentiment and also looked to establish a good recall with our audience about the Intellectual Property itself."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                This level of excitement and competition was achieved through the Hashtag and Call To Action of #GetRugged. Our content strategy involved sharing stories of winners from Track & Field, creating contests that took this same message forward in the form of emojis and even spoke about the various activities at the event in fun ways to get the dormant audience excited.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('img', {
    staticClass: "wide-img",
    attrs: {
      "src": require("../img/ruggedian-image-3.jpg")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("Social media posts were designed with  a rugged look and feel, images were used from the events in Kolhapur to give our targeted audience a sneak peak of the experience that awaited them.")]), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ruggedian-text-4.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("In a span of 45 Days we were successful in reaching out to 4 Lakh people across Pune, Mumbai and larger cities in Maharashtra with a total of around 15,000 Wesbite visits. We invoked the desire to compete amongst every persona identified from families to college graudates!"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          This was achieved through smart ways of optimising ads across Facebook, Instagram & Google PPC / Display campaigns. The event managed to garner nearly 2.5 Lakh impressions on Social Media channels of Facebook | Twitter | Instagram. This buzz resulted in generating ticket sales through online channels of over 1000 participants across all ages and personalities!")]), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ruggedian-text-5.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f95e358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RuggedianCaseStudy.vue
// module id = 157
// module chunks = 0